export default {"src":"/_next/static/media/reebelocare.b5b7a78c.svg","height":98,"width":97};